import AXIOS from "@/services/axios";

export default {
  list(appointmentId) {
    return AXIOS.get(`appointments/${appointmentId}/chat_messages`);
  },

  create(appointmentId, body) {
    return AXIOS.post(`appointments/${appointmentId}/chat_messages`, {
      chat_message: { body }
    });
  }
};
